import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { AssetsListResponse } from '@archimed/models';
import { firstValueFrom } from 'rxjs';
import { API_BASE_URL, AssetsApiPort } from '../../application/ports';

@Injectable()
export class AssetDefinitionsApiAdapter implements AssetsApiPort {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = inject(API_BASE_URL);

  async getAssetDefinitions(): Promise<AssetsListResponse> {
    return firstValueFrom(
      this.http.get<AssetsListResponse>(
        `${this.baseUrl}/api/asset-definitions`,
      ),
    );
  }
}
